<template>
    <div class="form-group col-12">
        <label for="songName">{{ $t('Add text') }}</label>
    </div>
    <!-- Song -->
    <Input type="text" name="song" id="song" classes="col-12" :placeholder="$t('Song name')" rules="required"
        :value="product.attributes.song" @updated-value="updatedInputField" />
    <!-- Interpret -->
    <Input type="text" name="interpret" id="interpret" classes="col-12" :placeholder="$t('Interpret')" rules="required"
        :value="product.attributes.interpret" @updated-value="updatedInputField" />
    <!-- Timeline -->
    <Timeline />
    <!-- QR -->
    <div class="attribute-group form-group col-12 radio-container qr">
        <!-- Radio -->
        <input type="checkbox" id="qr-checkbox" @change="toggleQR" v-model="showQR" />
        <label for="qr-checkbox">{{ $t('Create QR') }}</label>
        <!-- Text -->
        <div v-if="showQR" class="input-container">
            <Input type="text" name="qr" id="qr" classes="col-12" rules="required" :placeholder="$t('Type QR')"
                :value="product.attributes.qr" @updated-value="updatedInputField" />
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Input from '../Input';
import useMusic from '../../useMusic';
import useProduct from '../../useProduct';
import Timeline from './Timeline';

export default {
    components: {
        Input,
        Timeline
    },
    computed: {
        ...mapGetters({
            product: 'product/getProduct',
            showQR: 'product/getShowQR',
        })
    },
    setup() {
        const {
            toggleQR
        } = useMusic()
        const {
            updatedInputField
        } = useProduct()

        return {
            toggleQR,
            updatedInputField,
        }
    }
}
</script>